import { render, staticRenderFns } from "./EventRegistration.vue?vue&type=template&id=52391698"
import script from "./EventRegistration.vue?vue&type=script&lang=js"
export * from "./EventRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports